var CompanySize = {
	"Company size": "Ukuran Perusahaan",
	"1-19 employees": "1-19 Karyawan",
	"20-99 employees": "20-99 Karyawan",
	"100-499 employees": "100-499 Karyawan",
	"500-999 employees": "500-999 Karyawan",
	"1,000-9,999 employees": "1.000-9.999 Karyawan",
	"10,000 employees or more": "10.000 Karyawan Lebih"
};

export { CompanySize as default };
